import {
  fetchValidateResetToken,
  fetchVerifyEmail,
  fetchContactUs,
} from "./queries.js";

const validateResetToken = async (token) => {
  const result = await fetchValidateResetToken(token);

  if (result.message) {
    return { success: false, message: result.message };
  }

  return { ...result, success: true };
};

const verifyEmail = async (data) => {
  const result = await fetchVerifyEmail(data);

  if (result.message) {
    return { success: false, message: result.message };
  }

  return { ...result, success: true };
};

const contactUs = async (data) => {
  const result = await fetchContactUs(data);

  if (result.message) {
    return { success: false, message: result.message };
  }

  return { success: true };
};

export { validateResetToken, verifyEmail, contactUs };
